import { AgreementTemplate } from "../../templates/AgreementTemplate/AgreementTemplate";

export const AgreementPage = () => {
  return <AgreementTemplate />;
};
